import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, shareReplay, map, filter, retry, catchError } from 'rxjs/operators';
import { environment as env } from '@env/environment'
import { Observable } from 'rxjs';
import { Jwt } from '@models/system';
import { JwtService } from '@core/services';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private http: HttpClient) { }

    public get(auth: string) : Observable<Jwt> ;
    public get(usr: string, pwd: string) : Observable<Jwt> ;

    public get(auth: string, pwd?: string) : Observable<Jwt> {

        JwtService.clear();

        if(pwd !== undefined) {
            auth = 'BASIC ' + btoa(auth + ":" + pwd);
        }

        let headers = new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': auth
        });
        
        return this.http.get<Jwt>(env.API_URL + '/jwt', {headers: headers});
    }
}

